export const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365
